<template>
  <div class="request-list">
    <button
      class="btn btn-secondary mb-3 d-flex align-items-center"
      @click="$router.push('/')"
    >
      <span class="material-icons text-white me-1">arrow_back_ios</span>戻る
    </button>
    <h1 class="mb-3">申請&emsp;一覧</h1>
    <div class="content">
      <div>
        <bs-alert
          v-if="registeredMessage"
          :message="registeredMessage"
          color="success"
          closable
          @close="registeredMessage = ''"
        />

        <bs-alert
          v-if="errorMessage"
          :message="errorMessage"
          color="danger"
          closable
          @close="errorMessage = ''"
        />

        <div class="d-flex mb-3">
          <select
            v-model="filter.kind"
            class="form-select mx-2"
            style="width: 150px"
            @change="search()"
          >
            <option value="0">全て</option>
            <option v-for="(value, key) in kinds" :key="key" :value="key">
              {{ value }}
            </option>
          </select>

          <select
            v-model="filter.status"
            class="form-select mx-2"
            style="width: 150px"
            @change="search()"
          >
            <option value="1">未承認</option>
            <option value="2">承認済</option>
            <option value="0">却下</option>
          </select>
          <div class="ms-auto d-flex">
            <button
              class="btn btn-primary me-3 d-flex align-items-center"
              @click="$router.push('/request_form/0')"
            >
              <span class="material-icons text-white me-1">add</span>
              新しく申請する
            </button>
          </div>
        </div>
      </div>

      <div v-if="totalCount">
        {{ totalCount }}件中&ensp;{{ start_number }}件目～{{
          end_number
        }}件目を表示中
      </div>

      <div class="table-scroll">
        <table class="table table-hover sticky_table">
          <thead>
            <tr>
              <th>申請日</th>
              <th>申請者</th>
              <th>申請種別</th>
              <th>対象日</th>
              <th>申請数</th>
              <th>関連日</th>
              <th>申請理由</th>
              <th>ステータス</th>
              <th>更新日</th>
              <th>承認者</th>
            </tr>
          </thead>
          <tbody v-if="requests.length > 0">
            <tr
              v-for="request in requests"
              :key="request.id"
              @click="
                editRequest(
                  request.id,
                  request.employee.identification,
                  request.status
                )
              "
              :class="{ 'bg-secondary': request.status_text === '却下' }"
            >
              <td class="text-center">
                {{ request.request_date }}
              </td>
              <td>{{ request.employee.name }}</td>
              <td v-if="request.kind == 8">
                {{ request.kind_text }}({{ request.action_text }})
              </td>
              <td v-else>{{ request.kind_text }}</td>
              <td>{{ request.start_date.replaceAll("-", "/") }}</td>
              <td>{{ request.days }}日</td>
              <td v-if="request.related_date">
                {{ request.related_date.replaceAll("-", "/") }}
              </td>
              <td v-else></td>
              <td>{{ request.reason }}</td>
              <td>{{ request.status_text }}</td>
              <td>{{ request.updated_date }}</td>
              <td v-if="request.authorizer">{{ request.authorizer.name }}</td>
              <td v-else></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="10">登録がありません。</td>
            </tr>
          </tbody>
        </table>
      </div>

      <paginate-button
        :current-page="currentPage"
        :page-count="pageCount"
        :total-count="totalCount"
        @search="search($event)"
      />
    </div>
  </div>
</template>

<script>
import BsAlert from "@/components/Alert.vue";
import client from "@/plugins/axios";
import PaginateButton from "@/components/Paginate";

export default {
  name: "RequestList",
  components: { PaginateButton, BsAlert },
  data: () => ({
    registeredMessage: "",
    errorMessage: "",
    kinds: [],
    employee: "",
    filter: {
      kind: 0,
      status: 1,
    },
    requests: [],
    currentPage: 1,
    totalCount: 0,
    pageCount: 100,
  }),
  mounted() {
    this.init();
    if (this.$route.query.error) {
      this.errorMessage = this.$route.query.error;
    }
    if (this.$route.query.registered) {
      this.registeredMessage = `${this.$route.query.registered}を登録しました。`;
    }
    if (this.$route.query.approved && this.$route.query.status) {
      this.registeredMessage = `${this.$route.query.approved}を${this.$route.query.status}しました。`;
    }
  },
  computed: {
    start_number() {
      return this.pageCount * (this.currentPage - 1) + 1;
    },
    end_number() {
      return this.pageCount * (this.currentPage - 1) + this.requests.length;
    },
  },
  methods: {
    init() {
      this.$emit("loading", true);
      this.employee = this.$store.getters["user/user"];

      client.get("/api/request/choices").then((res) => {
        this.kinds = res.data.kinds;
      });

      if (
        this.$store.getters["search/request"] &&
        Object.keys(this.$store.getters["search/request"]).length
      ) {
        this.filter = { ...this.$store.getters["search/request"] };
      }
      this.search();
    },
    search(page = 1) {
      this.$emit("loading", true);
      this.$store.dispatch("search/setRequest", this.filter);
      this.currentPage = page;
      const params = { ...this.filter };
      params["count"] = this.pageCount;
      params["page"] = this.currentPage;

      client
        .get("/api/request/request_list", { params: params })
        .then((res) => {
          this.requests = res.data.results;
          this.totalCount = res.data.count;
          this.$emit("loading", false);
        })
        .catch((error) => {
          console.error(error);
          this.$emit("loading", false);
        });
    },
    editRequest(id, identification, status) {
      if (this.employee.identification == identification && status == 3) {
        window.location.href = "#/request_form/" + id;
      } else if (
        this.employee.identification != identification &&
        status == 1 &&
        this.employee.access_right == 2
      ) {
        window.location.href = "#/approval/" + id;
      } else {
        this.$router.push(`/request_detail/${id}`);
      }
    },
  },
};
</script>

<style scoped>
tbody tr:hover {
  cursor: pointer;
}
@media screen {
  .table-scroll {
    max-height: 60vh;
    overflow: auto;
  }
  .sticky_table thead th {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  .sticky_table th:first-child {
    position: -webkit-sticky;
    position: sticky;
    left: 0;
  }
  .sticky_table thead th:first-child {
    z-index: 2;
  }
  .print-area * {
    display: none;
  }
}
@media print {
  button *,
  br,
  div.no-print * {
    display: none !important;
  }
  thead * {
    -webkit-print-color-adjust: exact;
  }
  .table-scroll {
    margin: 0;
  }
}
@page {
  size: A4;
  margin: -10px;
  padding: 0;
}
</style>
